import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-sanierung-co2',
  templateUrl: './sanierung-co2.component.html'
})
export class SanierungCo2Component {

  /**
   * basic values for the reduction calution
   */
  @Input() consumption: { co2: { current: number; sanitized: number; percent: number, recommend: number }; kwh: { current: number; sanitized: number; percent: number, recommend: number } };

  /**
   * toggle for the details
   */
  showDetails: boolean = false;

  /**
   * calculates the with of the bar
   */
  getWidth(): number {
    return Math.max(0, this.consumption.co2.sanitized / this.consumption.co2.current * 100);
  }

  /**
   * calculates the reduction percentage
   */
  getReduction(): number {
    return Math.min(100, 100 - (this.consumption.co2.sanitized / this.consumption.co2.current * 100));
  }

  /**
   * toggle to show/hide details in climate module
   */
  onClickShowDetails(): void {
    this.showDetails = !this.showDetails;
  }

}
